import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Sparkles,
  FileText,
  ArrowRight,
  AlertCircle,
  Clock,
  CreditCard,
  Truck,
  RotateCcw,
} from "lucide-react";
import conditionsContent from "../data/content/conditions-commande.json";

const sectionIcons = [FileText, Clock, CreditCard, Truck, RotateCcw, AlertCircle];

const ConditionsCommandePage = () => {
  const sections = Array.isArray(conditionsContent?.sections)
    ? conditionsContent.sections.filter((section) => section && typeof section === "object")
    : [];
  const callToAction = conditionsContent?.cta && typeof conditionsContent.cta === "object"
    ? conditionsContent.cta
    : {};

  return (
    <div className="pt-24 pb-16 min-h-screen bg-[#F6F7F1]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#D4AF37]" />
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="h-px w-16 bg-[#D4AF37]" />
          </div>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {typeof conditionsContent?.title === "string" ? conditionsContent.title : "Conditions de commande"}
          </h1>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            {typeof conditionsContent?.intro === "string" ? conditionsContent.intro : ""}
          </p>
        </motion.div>

        <div className="space-y-8">
          {sections.map((section, index) => {
            const Icon = sectionIcons[index] || FileText;
            return (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className={`rounded-2xl p-8 ${
                  index % 2 === 0
                    ? "bg-[#FFF5F8]"
                    : "bg-white border border-gray-100"
                }`}
              >
                <h2 className="font-playfair text-xl font-bold text-gray-900 mb-5 flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-[#E5007D]/10 flex items-center justify-center text-[#E5007D]">
                    <Icon className="w-5 h-5" />
                  </div>
                  {typeof section.title === "string" ? section.title : "Conditions"}
                </h2>
                <ul className="space-y-3">
                  {(Array.isArray(section.paragraphs) ? section.paragraphs : [])
                    .filter((paragraph) => typeof paragraph === "string" && paragraph.length > 0)
                    .map((paragraph, paragraphIndex) => (
                    <li
                      key={`${section.title}-${paragraphIndex}`}
                      className="text-gray-600 text-sm leading-relaxed pl-4 border-l-2 border-[#E5007D]/20"
                    >
                      {paragraph}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 text-center bg-gradient-to-br from-[#E5007D] to-[#c70069] rounded-2xl p-10"
        >
          <h3 className="font-playfair text-2xl font-bold text-white mb-3">
            {typeof callToAction.title === "string" ? callToAction.title : ""}
          </h3>
          <p className="text-white/80 text-sm mb-6">
            {typeof callToAction.description === "string" ? callToAction.description : ""}
          </p>
          <Link
            to="/commande"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white text-[#E5007D] rounded-full font-semibold text-sm hover:bg-gray-50 transition-all duration-300 shadow-lg"
          >
            {typeof callToAction.button === "string" ? callToAction.button : ""}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default ConditionsCommandePage;
